import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "data", "dataUnit", "dataKey", "gradients", "areas", "xAxisOptions", "yAxisOptions", "gridOptions", "showXAxis", "showYAxis", "showGrid", "legend", "brush", "tooltip"],
  _excluded2 = ["strokeColor"];
import React from 'react';
import { AreaChart as RechartsAreaChart, Area as RechartsArea, Legend as RechartsLegend, XAxis, YAxis, Brush, Tooltip as RechartsTooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import { getColor, mapGridOptions } from './chartHelper';
import AreaGradient from './AreaGradient';
import ChartTooltip from './ChartTooltip';
var AreaChart = function AreaChart(props) {
  var width = props.width,
    height = props.height,
    data = props.data,
    dataUnit = props.dataUnit,
    dataKey = props.dataKey,
    gradients = props.gradients,
    areas = props.areas,
    xAxisOptions = props.xAxisOptions,
    yAxisOptions = props.yAxisOptions,
    gridOptions = props.gridOptions,
    showXAxis = props.showXAxis,
    showYAxis = props.showYAxis,
    showGrid = props.showGrid,
    legend = props.legend,
    brush = props.brush,
    tooltip = props.tooltip,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var areasWithGradient = areas.map(function (area) {
    var _area$props = area.props,
      strokeColor = _area$props.strokeColor,
      remainingAreaProps = _objectWithoutProperties(_area$props, _excluded2);
    var gradientId = area.key;
    var stroke = getColor(strokeColor);
    return {
      area: /*#__PURE__*/React.createElement(RechartsArea, _extends({}, remainingAreaProps, {
        key: area.key,
        stroke: stroke,
        fill: "url(#".concat(gradientId, ")")
      })),
      gradient: /*#__PURE__*/React.createElement(AreaGradient, {
        key: area.key,
        id: gradientId,
        color: strokeColor
      })
    };
  });
  return /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement(RechartsAreaChart, _extends({
    width: width,
    height: height,
    data: data,
    margin: {
      top: 15,
      right: 15,
      left: 15,
      bottom: 15
    }
  }, remainingProps), /*#__PURE__*/React.createElement("defs", null, gradients, areasWithGradient.map(function (areaWithGradient) {
    return areaWithGradient.gradient;
  })), showGrid && /*#__PURE__*/React.createElement(CartesianGrid, _extends({
    strokeDasharray: "3 3"
  }, mapGridOptions(gridOptions))), /*#__PURE__*/React.createElement(XAxis, _extends({
    hide: !showXAxis,
    dataKey: dataKey
  }, xAxisOptions)), /*#__PURE__*/React.createElement(YAxis, _extends({
    hide: !showYAxis,
    unit: dataUnit
  }, yAxisOptions)), tooltip && /*#__PURE__*/React.createElement(RechartsTooltip, tooltip.props), legend && /*#__PURE__*/React.createElement(RechartsLegend, _extends({
    wrapperStyle: legend.props.verticalAlign === 'bottom' ? {
      bottom: 0
    } : legend.props.wrapperStyle
  }, legend.props)), areasWithGradient.map(function (areaWithGradient) {
    return areaWithGradient.area;
  }), brush && /*#__PURE__*/React.createElement(Brush, {
    stroke: getColor('gray')
  })));
};
AreaChart.defaultProps = {
  width: 480,
  height: 200,
  data: [],
  dataUnit: '',
  // dataKey,
  gradients: [],
  areas: [],
  // xAxisOptions,
  // yAxisOptions,
  // gridOptions,
  showXAxis: true,
  showYAxis: false,
  showGrid: false,
  // legend,
  brush: false,
  tooltip: /*#__PURE__*/React.createElement(ChartTooltip, null)
};
export default AreaChart;